export enum MoreOrLessEnum {
    increase,
    decrease
}
